import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$companyId/spaces/$spaceId/settings',
      params: { companyId: params.companyId, spaceId: params.spaceId },
    })
  },
})
